<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/serviceIndex' }"
          >客户服务管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/rServiceDetail' }"
          >客户详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>客户订单记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="order_money_state flex-rowl">
          <div class="item">
            <p>
              所有订单金额总计：<span
                >￥ {{ orderTotalPrice | formatPrice }}</span
              >
            </p>
            <p>
              已收款总计：<span>￥ {{ completeTotalPrice | formatPrice }}</span>
            </p>
            <p>
              待收款总计：<span>￥ {{ noTotalPrice | formatPrice }}</span>
            </p>
          </div>
          <div class="item">
            <p>
              已完成订单数量：<span>{{ completeNum }}</span>
            </p>
            <p>
              未完成订单数量：<span>{{ noNum }}</span>
            </p>
          </div>
        </div>
        <div class="filter">
          <div class="flex-rowr">
            <el-select
              v-model="orderState"
              @change="changeOrderState"
              placeholder="订单状态"
            >
              <el-option
                v-for="(item, index) in stateList"
                :key="index"
                :label="item.txt"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="search_wrap flex-between">
              <el-input
                v-model="params.keyword"
                placeholder="输入关键字查找→"
                @keyup.enter.native="handleSearch()"
              ></el-input>
              <div class="search_btn flex-rowc" @click="handleSearch">
                <i class="iconfont icon-chazhaotubiao"></i>
              </div>
            </div>
          </div>
          <div class="date_wrap flex-rowr">
            <div class="start_date">
              <el-date-picker
                v-model="startDataValue"
                type="date"
                alue-format="yyyy-MM-dd"
                placeholder="设置起始时间"
              >
              </el-date-picker>
            </div>
            <div class="start_end">
              <el-date-picker
                v-model="endDataValue"
                type="date"
                alue-format="yyyy-MM-dd"
                placeholder="设置结束时间"
              >
              </el-date-picker>
            </div>
            <div class="btn query" @click="handleLook">查找</div>
            <div class="btn" @click="handleResut">重置</div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div
                class="content_wrap flex-between"
                @click="handleDetail(item.id, item.openid)"
              >
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      订单编号：<span>{{ item.orderno }}</span>
                    </p>
                    <p>
                      创建时间：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                    <p>
                      {{item.ordertypestr}}
                    </p>
                    <p>
                      销售专员姓名：<span>{{ item.saler }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <div class="shop_name_num_item flex-rowl">
                      <p class="label">商品数量：</p>
                      <p>
                        <span>{{ item.totalNum }}</span>
                      </p>
                    </div>
                    <p v-for="(itemChild, indexChild) in item.goods" :key="indexChild">
                      商品名称：<span>{{ itemChild.commodityname }}</span>
                    </p>
                    <div class="shop_price" v-if="false">
                      <p>
                        成本参考价：<span v-if="item.cbprice_sum"
                          >¥ {{ item.cbprice_sum }}</span
                        >
                      </p>
                      <p>
                        基础零售价：<span v-if="item.price_sum"
                          >¥ {{ item.price_sum }}</span
                        >
                      </p>
                      <p>
                        批发参考价：<span v-if="item.pfprice_sum"
                          >¥ {{ item.pfprice_sum }}</span
                        >
                      </p>
                      <p>
                        基础批发价：<span v-if="item.groupprice_sum"
                          >¥ {{ item.groupprice_sum }}</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="block" v-if="false">
                    <div
                      class="shop_item"
                      v-for="(itemChild, itemIndex) in item.goods"
                      :key="itemIndex"
                    >
                      <div class="shop_name_num">
                        <!-- <div class="shop_name_num_item flex-rowl">
                          <p class="label">商品名称：</p>
                          <p>
                            <span>{{ itemChild.commodityname }}</span>
                          </p>
                        </div> -->
                        <div class="shop_name_num_item flex-rowl">
                          <p class="label">商品数量：</p>
                          <p>
                            <span>{{ itemChild.num }}</span>
                          </p>
                        </div>
                      </div>
                      <div class="shop_price">
                        <p>成本参考价：<span></span></p>
                        <p>基础零售价：<span></span></p>
                        <p>批发参考价：<span></span></p>
                        <p>基础批发价：<span></span></p>
                      </div>
                    </div>
                  </div>
                  <div class="block">
                    <p>
                      订单价格核算：<span v-if="item.price_original"
                        >￥{{ item.price_original | formatPrice }}</span
                      >
                    </p>
                    <p>
                      物流费用：
                      <span v-if="item.logisticsdf == 1">到付</span>
            <span v-else>￥{{ item.runfee ? item.runfee : '0.00' }}</span>
                    </p>
                    <div class="txt flex-rowl">
                      <p>实际订单价格：</p>
                      <p>
                        <span>￥{{ item.price | formatPrice }}</span>
                      </p>
                    </div>
                    <!-- <div class="txt1 flex-rowl">
                      <p>差额：</p>
                      <p>
                        <span>￥{{ item.runfee }}</span>
                      </p>
                    </div> -->
                    <div class="txt2 flex-rowl">
                      <p>已付金额：</p>
                      <p>
                        <span v-if="item.paynum">￥{{ item.paynum | formatPrice }}</span>
                        <span v-else>￥ 0.00</span>
                      </p>
                    </div>
                    <div class="txt2 flex-rowl">
                      <p>差额：</p>
                      <p>
                        <span>￥{{ item.diffrentprice | formatPrice }}</span>
                      </p>
                    </div>
                    <div class="txt2 flex-rowl">
                      <p>待结清金额：</p>
                      <p>
                        <span>￥{{ item.waitMoney | formatPrice }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="block">
                    <p>
                      订单审核状态：<span class="red">{{
                        item.ischeck == 0
                          ? "待审核"
                          : item.ischeck == 1
                          ? "审核通过"
                          : item.ischeck == 2
                          ? "审核不通过"
                          : ""
                      }}</span>
                    </p>
                    <p>
                      退费申请状态：<span class="red">{{
                        item.isreturn === true
                          ? "是"
                          : item.isreturn === false
                          ? "否"
                          : "无"
                      }}</span>
                    </p>
                    <p>
                      退费状态：<span class="red">{{
                        item.returnstate ? item.returnstate : '无'}}</span>
                    </p>
                    <p>
                      订单情况：<span class="red">{{
                        item.ordertalk == 1
                          ? "进行中"
                          : item.ordertalk == 2
                          ? "已完成"
                          : item.ordertalk == 3
                          ? "已关闭"
                          : "无"
                      }}</span>
                    </p>
                    <p>
                      发货情况：<span class="red">{{ item.orderstate }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>客户名称：<span>{{item.qy_truename}}</span></p>
                    <p>客户企业：<span>{{item.qw_appidstr}}</span></p>
                    <p>客户职务：<span>{{item.qw_job}}</span></p>
                    <p>联系方式：<span>{{item.qy_linktype}}</span></p>
                  </div>
                </div>
              </div>
              <div class="edit_group flex-rowr">
                <div class="detail_icon" @click="handleDetail(item.id, item.openid)">
                  <i class="iconfont icon-details"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty
          description="暂无入库记录"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->
    <div class="form_footer flex-rowl">
      <div class="btn" @click="handleGo">新建订单</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
  </div>
</template>
<script>
import { encryptstringadd, encryptstringview } from "../../../api/api";
import { getOrderList } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "rServiceRecordList",
  data() {
    return {
      id: "",
      // stateList: [
      //   "全部",
      //   "待审核",
      //   "审核通过",
      //   "审核不通过",
      //   "支付未完成",
      //   "已支付完成",
      //   "退费申请待审核",
      //   "退费申请不通过",
      //   "退款中",
      //   "已退款",
      // ],
      stateList: [
        {
          txt: "全部",
          type: "",
          state: "",
          vvalue: "",
        },
        {
          txt: "待审核",
          type: "ischeck",
          state: 0,
          value: "ischeck-0",
        },
        {
          txt: "审核通过",
          type: "ischeck",
          state: 1,
          value: "ischeck-1",
        },
        {
          txt: "支付未完成",
          type: "paystate",
          state: 0,
          value: "paystate-0",
        },
        {
          txt: "已支付完成",
          type: "paystate",
          state: 1,
          value: "paystate-1",
        },
        {
          txt: "退款中",
          type: "returntalk",
          state: 1,
          value: "returntalk-1",
        },
        {
          txt: "已退款",
          type: "returntalk",
          state: 2,
          value: "returntalk-2",
        },
      ],
      orderState: "",

      show: false,
      minDate: new Date(),
      timeType: "",
      startTime: "",
      endTime: "",

      dataList: [],
      loading: true,
      startDataValue: "",
      endDataValue: "",
      params: {
        // openid: "o6LS_63aFOa1Ec2p1p0wUpQ6NHCA",
        openid: this.$store.state.OPENID,
        qyid: this.$store.state.USERINFO.qy
          ? this.$store.state.USERINFO.qy.id
          : 0,
        ordertype: 43, // 订单类型 43=销售业务订单
        returntalk: "", // 退款状态 =1=退款中 2=已退款
        ischeck: "", // 订单审核 =0=待审核 1=审核通过 2=审核不通过
        paystate: "", // 支付状态 =0=未支付 1=已支付
        orderstate: "", // 订单状态 =未支付 待发货 已发货 已完成 已申请退费 已退费
        keyword: "",
      },
      orderTotalPrice: 0, // 订单总金额
      completeTotalPrice: 0, // 已收款总计
      noTotalPrice: 0, // 待收款总计
      completeNum: 0, // 已完成订单数量
      noNum: 0, //未完成订单数量
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getOrderList();
      } else {
        this.$router.back();
      }
    },

    // 获取商品订单
    getOrderList() {
      getOrderList(this.params).then((res) => {
        console.log(res, "=======");
        res.forEach((v) => {
          if (v.goods.length > 0) {
            v.totalNum = 0;
            v.goods.forEach((v1) => {
              v.totalNum += v1.num;
            });
          }
          // 支付状态orderstate 未支付
          if (v.orderstate == "未支付") {
            this.noTotalPrice = calculator(this.noTotalPrice)
              .add(v.price)
              .toNumber();
          } else {
            this.completeTotalPrice = calculator(this.completeTotalPrice)
              .add(v.price)
              .toNumber();
          }
          // 订单状态
          // ordertalk 2-已完成
          if (v.ordertalk == 2) {
            this.completeNum = calculator(this.completeNum)
              .add(v.totalNum)
              .toNumber();
          } else {
            this.noNum = calculator(this.noNum).add(v.totalNum).toNumber();
          }
          this.orderTotalPrice = calculator(this.orderTotalPrice)
            .add(v.price)
            .toNumber();
           // 待结清金额 = price - paynum
          v.waitMoney = calculator(v.price)
            .subtract(v.paynum ? v.paynum : 0)
            .toNumber()
        });
        this.dataList = res;
        this.loading = false;
      });
    },

    // 选中下拉状态
    changeOrderState(e) {
      if (!e) {
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.paystate = "";
        this.getOrderList();
        return;
      }
      let [type, state] = e.split("-");
      if (type == "returntalk") {
        this.params.returntalk = state;
        this.params.ischeck = "";
        this.params.paystate = "";
      } else if (type == "ischeck") {
        this.params.ischeck = state;
        this.params.returntalk = "";
        this.params.paystate = "";
      } else if (type == "paystate") {
        this.params.paystate = state;
        this.params.returntalk = "";
        this.params.ischeck = "";
      }
      // this.orderTotalPrice = 0
      // this.completeTotalPrice = 0
      // this.noTotalPrice = 0
      // this.completeNum = 0
      // this.noNum = 0
      // this.getOrderList();
    },
    handleSearch() {
      this.orderTotalPrice = 0
      this.completeTotalPrice = 0
      this.noTotalPrice = 0
      this.completeNum = 0
      this.noNum = 0
      this.getOrderList();
    },
    // 查找
    handleLook() {
      this.orderTotalPrice = 0
      this.completeTotalPrice = 0
      this.noTotalPrice = 0
      this.completeNum = 0
      this.noNum = 0
      this.getOrderList()
    },
    // 重置
    handleResut() {
      this.orderTotalPrice = 0
      this.completeTotalPrice = 0
      this.noTotalPrice = 0
      this.completeNum = 0
      this.noNum = 0
      this.params.returntalk = ''
      this.params.ischeck = ''
      this.params.paystate = ''
      this.params.orderstate = ''
      this.params.keyword = ''
      this.getOrderList()
    },
    handleReturn() {
      this.$router.back();
    },
    handleGo() {
      // this.$router.push(`/resourceIndex/rServiceAddOrder/${this.id}`);
      this.encryptstringadd("rServiceAddOrder", { id: this.id });
    },

    handleDetail(id, openid) {
      this.encryptstringadd("cOrderDetail", { id, openid, type : 'rServiceRecordList'});
      // this.$router.push(`/comSalesIndex/cOrderDetail/${id}/${openid}/${this.type}`);
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .operation_wrap {
    height: auto;
    padding: 10px 0;
    .order_money_state {
      font-size: 16px;
      align-items: flex-start;
      .item {
        margin-right: 20px;
        p {
          &:nth-child(2) {
            margin: 10px 0;
          }
        }
      }
    }
    .date_wrap {
      margin-top: 10px;
      .start_date {
        margin-right: 10px;
      }
      .btn {
        font-size: 14px;
        background: #1e1e1e;
        color: #fff;
        height: 40px;
        line-height: 40px;
        text-align: center;
        padding: 0 20px;
        cursor: pointer;
        &.query {
          margin: 0 10px 0 20px;
        }
      }
    }
    .search_wrap {
      margin-left: 10px;
      width: 270px;
    }
  }
  .list_wrap {
    height: 46vh;
    .item_main_wrap {
      cursor: pointer;
      .address_wrap {
        width: 28%;
      }
      .customer_wrap {
        span {
          height: 40px;
          border: 1px solid #d2d2d2;
          font-size: 12px;
          padding: 0 10px;
          margin-right: 5px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      // .intro_box {
      //   cursor: pointer;
      // }
      .shop_item {
        margin-bottom: 10px;
        font-size: 14px;
      }
    }
    .red {
      color: #ff0036;
    }
  }
}
</style>